import * as screenfull from "screenfull";
import { JwtHelperService } from "@auth0/angular-jwt";
import { TranslateService } from "@ngstack/translate";
import { Component, EventEmitter, Output, OnInit } from "@angular/core";

import { AccountService } from "src/app/services/http/business/account/account.service";
import { Router } from "@angular/router";
import { ContractService } from "src/app/services/http/business/contract/contract.service";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { QuickSearchCoursesComponent } from "src/app/core/quick-search-courses/quick-search-courses.component";
import { MatDialog } from "@angular/material";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html"
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidenav = new EventEmitter<void>();
  @Output() toggleNotificationSidenav = new EventEmitter<void>();
  isOwner: boolean;
  userInfo: any;
  branchRole: any;
  token = localStorage.getItem("token");
  hasCurentUserTeacherContract: boolean;
  constructor(
    private router: Router,
    private accountService: AccountService,
    private dialog: MatDialog,
    private holdingService: HoldingService,
    public translateService: TranslateService,
    private contractService: ContractService,
    private cidService: CIDService
  ) { }

  ngOnInit() {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(this.token);
    this.userInfo = decodedToken.fname;
    this.branchRole = this.cidService.getBrnachRoleName();
    this.checkIsTeacher();
    this.checkOwner();
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
    });
  }
  quickSearch() {
    this.dialog
      .open(QuickSearchCoursesComponent, {
        width: '98%'
      })
  }

  placement() {
    this.router.navigate(['management/placementreservation'])
  }
  registration() {
    this.router.navigate(['management/register/registration'])
  }

  fullScreenToggle(): void {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }
  logout() {
    this.accountService.logout();
  }

  navigateToHome() {
    this.router.navigate(["hbr"])
  }
  home() {
    this.router.navigate(['/'])
  }
  showStudentSessionsCheckout() {
    this.router.navigate(['management/studentsessionscheckout'])
  }
  checkIsTeacher() {
    this.contractService.hasCurentUserTeacherContract(this.cidService.getCID()).subscribe(res => {
      this.hasCurentUserTeacherContract = res.HasCurentUserTeacherContract;
    });
  }
}
